import React from 'react';
import {
    RichCell,
    Button, SplitLayout, SplitCol, Div, NativeSelect
} from '@vkontakte/vkui';
import {
    AdaptivityContext
} from "../../assets/constants";


import {
    Icon20AddCircleFillGreen,
    Icon20EditCircleFillBlue,
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import StandsApi from "../../api/references/stands";
import StandsManagers from "../../api/references/managers/standsManagers";
import BaseList from "../../components/BaseList";
import * as constants from "../../assets/constants";
import withOffline from "../../components/withOffline";


class StandsList extends BaseList {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            confirmationFilter: 'all'
        }
    }

    // Дополнительные поля для сохранения состояния
    getAdditionalStateToSave() {
        return {
            confirmationFilter: this.state.confirmationFilter
        };
    }

    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);

        console.log(this.state)

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch ?? ''
        }

        const {confirmationFilter = 'all'} = this.state
        const requestParams = {
            isOffline: this.props.isOffline,
            search: mainSearch,
            page,
            epp: AdaptivityContext.isMobile ? 10 : 20
        }

        if (confirmationFilter === 'not_confirmed') {
            requestParams.only_not_confirmed = 0
        } else if (confirmationFilter === 'confirmed') {
            requestParams.only_not_confirmed = 1
        }

        StandsManagers.getList(
            requestParams
        ).then(response => {

            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'brand', id: item.id};
    }

    createItem = () => {
        window.postMessage({
            type: 'setCurrentBrand',
            value: {id: -1}
        })
    }
    handleConfirmationFilterChange = (event) => {
        const value = event.target.value

        this.setState({
            confirmationFilter: value,
            loading: true,
            page: 1,
            items: []
        }, () => this.getItems('', false, 1))
    }
    getItem = (item) => {
        this.setLastOpenedItem(item.id);
        StandsApi.getOne(item.id).then(response => {
            const {data} = response

            if (data.id) {
                window.postMessage({type: 'setCurrentBrand', value: data})
            }
        })
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        <Button mode="outline"
                                onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>

                    </Div>
                </SplitCol>

                <SplitCol>
                    <Div style={{display: 'flex', flexDirection: 'column'}}>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>
                        <NativeSelect
                            value={this.state.confirmationFilter}
                            onChange={this.handleConfirmationFilterChange}
                            style={{marginTop: 8, maxWidth: 280}}
                        >
                            <option value="all">Все</option>
                            <option value="not_confirmed">Только не подтвержденные</option>
                            <option value="confirmed">Только подтвержденные</option>
                        </NativeSelect>
                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }
    types = constants.getEquipmentTypes()
    trade_marks = constants.getTrademarks()
    renderRow = (item, index) => {
        let backgroundColor = 'inherit'

        if (item.is_competitor) {
            backgroundColor = 'rgba(88,117,183,0.4)'
        }

        if (item.confirmed == 0) {
            backgroundColor = 'rgba(255,75,75,0.57)'
        }
        return <RichCell multiline
                         subhead={<div style={{
                             display: "flex",
                             flexDirection: "row",
                             alignItems: 'center'
                         }}>{<div>{item.is_competitor ? 'Конкурент' : ''} {item.deleted ?
                             <b>{'[Запрет ввода]'}</b> : ''}</div>}
                             {item.parent_id &&
                                 <div className="summary-chip danger">{'Аналог ' + item.parent_id.title}</div>}
                         </div>}
                         style={this.getRowStyle(item, { backgroundColor })}
                         bottom={<div>

                             {item.childs && Array.isArray(item.childs) && item.childs.length > 0 &&
                                 <div style={{
                                     display: "flex",
                                     flexDirection: "row",
                                     alignItems: 'center'
                                 }}>Аналоги: {item.childs.map(child => <div
                                     className="summary-chip">{child.title}</div>)}</div>}
                         </div>
                         }
                         caption={
                             <div style={{
                                 display: "flex",
                                 gap: 21,

                                 justifyContent: 'flex-start'
                             }}>
                                 {item.confirmed == 0 ? <span style={{color: 'red'}}>Не пройдена модерация</span> : ''}
                                 {item.trade_mark_id > 0 ? <span>Торговая марка: <b>{this.trade_marks[item.trade_mark_id]}</b></span> :
                                     <b>Без торговой марки</b>}
                             </div>}
                         afterCaption={<div style={{display: "flex", flexDirection: "column"}}>
                             <Button mode="outline" size="m"
                                     onClick={() => this.getItem(item)}><Icon20EditCircleFillBlue/></Button>

                         </div>
                         }
        >
            {item.title} {item.type_id > 0 ? <b>{this.types[item.type_id]}</b> : <b>Тип не указан</b>}
        </RichCell>
    }

}

export default withOffline(StandsList)